import { createContext } from "react";

export const EnvironmentContext = createContext({});

export const EnvironmentProvider = ({ children }) => (
    <EnvironmentContext.Provider value={window.environment}>
        {children}
    </EnvironmentContext.Provider>
);